import { render } from "./watchlist.vue?vue&type=template&id=ef5ed700"
import script from "./watchlist.vue?vue&type=script&lang=js"
export * from "./watchlist.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__